/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'confluence-analytics-chart.default-loading-text': 'Odświeżanie danych analitycznych...',
  'confluence-analytics-chart.tooltip.no-views-data': 'Brak danych',
  'confluence-analytics-chart.tooltip.views-overall':
    '{count, plural, one {1 wyświetlenie} few {{count} wyświetlenia} many {{count} wyświetleń} other {{count} wyświetlenia}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 wyświetlenie do tej pory} few {{count} wyświetlenia do tej pory} many {{count} wyświetleń do tej pory} other {{count} wyświetlenia do tej pory}}',
  'confuence-analytics-chart.accessible-table.caption': 'Wyświetlenia strony',
  'confuence-analytics-chart.accessible-table.header.date': 'Data',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Wyświetlenia',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Brak wyświetleń',
};
